import React from 'react'
import './features.css'

import { FeatureCard } from '../../components'

import MonitoringLogo from '../../assets/MonitoringLogo.svg'
import WidgetLogo from '../../assets/WidgetLogo.svg'
import PerformanceLogo from '../../assets/PerformanceLogo.svg'

const Features = () => {
  return (
    <div className="features__container section__padding" id='features'>
      <div className="features__header">
        <h2>Main Features</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Elementum nisi aliquet volutpat pellentesque volutpat est.
          Sapien in etiam vitae nibh nunc mattis imperdiet sed nullam.
          Vitae et, tortor pulvinar risus pulvinar sit amet. Id vel
          in nam malesuada.
        </p>
      </div>
      <div className="features__cards-container">
        <FeatureCard
          title="Monitoring 24/7"
          description="Lorem ipsum dolor sit amet, consectetur adipis cing elit. Elementum nisi aliquet volutpat."
          logo={MonitoringLogo}
        />
        <FeatureCard
          title="Widget System"
          description="Sapien in etiam vitae nibh nunc mattis imperdiet sed nullam. Vitae et, tortor pulvinar risus pulvinar."
          logo={WidgetLogo}
        />
        <FeatureCard
          title="Best Performance"
          description="Lorem ipsum dolor sit amet, consectetur adipis cing elit. Elementum nisi aliquet volutpat."
          logo={PerformanceLogo}
        />
      </div>
    </div>
  )
}

export default Features
